import { z } from "zod"


export const TemplateIdsSchema = z.record(
  z.coerce.number().int(),  // Variant ID
  z.string().nullable()     // Template ID metafield value
);

export type TemplateIds = z.infer<typeof TemplateIdsSchema>
